export class SIQFeedbackTheme {
  backgroundColor = "null";
  primaryTextColor = "null";
  secondaryTextColor = "null";
  skipButtonTextColor = "null";
  submitButtonTextColor = "null";
  submitButtonBackgroundColor = "null";
  feedbackTextFieldTintColor = "null";
  feedbackPlaceholderTextColor = "null";
}
//# sourceMappingURL=SIQFeedbackTheme.js.map